import { levelGeneralListData } from '../models/level-general-list-data';

// Eén definitie van "inactieve rij" voor de lijst-tools (dimmen, inactiveMode, uitvinken in edit-modus).
// Heeft de rij een eigen `active`-veld (FunctionMember/DomainUser/ProjectMember: ook verlopen EndDate,
// cascade van de DomainUser), dan telt dat; anders het backend-oordeel `inactive`.
export function listItem_isInactive(item: object | null | undefined): boolean {
    if (!item) return false;
    const __item = item as { active?: boolean; [levelGeneralListData.inactive]?: boolean };
    return 'active' in __item
        ? __item.active === false
        : __item[levelGeneralListData.inactive] === true;
}
